import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import Snackbar from './Snackbar'

import {
  activeSelector,
  timeoutSelector,
  typeSelector,
  messageSelector,
} from './selectors'

const mapStateToProps = (state) => {
  return {
    active: activeSelector(state),
    type: typeSelector(state),
    message: messageSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

const Notification = props => {
  return (
    <Snackbar {...props}/>
  )
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect
)

export default enhance(Notification)
